import React from 'react';
import { useSelector } from 'react-redux';

import noop from 'lodash/noop';
import get from 'lodash/get';

import { DatasetInspectorContainer } from '../../components/dataset-inspector/DatasetInspectorContainer';

import type { RouteComponentProps } from 'react-router';
import type { RootState } from '../../types/state.types';

import '../../components/pipe-output/PipeOutputStyle.css';

export const PipeDeadLetters: React.FC<
  RouteComponentProps<{}, any> & {
    addCustomActions: () => void;
    removeCustomActions: () => void;
    registerRefresh: () => void;
    unregisterRefresh: () => void;
  }
> = ({
  params,
  router,
  addCustomActions = noop,
  removeCustomActions = noop,
  registerRefresh = noop,
  unregisterRefresh = noop,
}) => {
  const { subId, pipeID } = params;
  const inputPipe = useSelector((state: RootState) => state.pipes[pipeID]);
  const datasetID = get(inputPipe, 'config.effective.pump.dead_letter_dataset');
  const targetDatasetId = inputPipe?.config?.effective?.source?.dataset;

  if (!params.pipeID) {
    router.push(`/subscription/${subId}/pipes/all`);

    return null;
  }

  if (inputPipe && !datasetID) {
    router.push(`/subscription/${subId}/pipes/pipe/${inputPipe.link}/dashboard`);

    return null;
  }

  return (
    <DatasetInspectorContainer
      datasetId={datasetID}
      targetDatasetId={targetDatasetId}
      registerRefresh={registerRefresh}
      unregisterRefresh={unregisterRefresh}
      addCustomActions={addCustomActions}
      removeCustomActions={removeCustomActions}
      tab="dead-letters"
      displayRepostAll={true}
    />
  );
};
